module.exports = "/static/media/lineto-circular-bold.6ca9638f.eot";